import { useEffect, useState } from "react";
import { AvailabilitiesDay } from "./AvailabilitiesDay";
import { useAuth } from "../../contexts/auth/AppAuthContext";
import { DaysOfWeek, TutorProfileSchema, TutorSchedule, TutorScheduleNoTimeZone } from "../../firestore/Types/TutorProfileSchema";
import { updateTutorSchedule } from "../../firestore/Functions/tutorScheduleFunctions";
import { getDayFromChar } from "../../Utils/WeekdayHelpers";

export function Availabilities({ tutorProfile, handleRefresProfile } : { tutorProfile: TutorProfileSchema, handleRefresProfile: () => Promise<void> }) {
    const [availabilities, setAvailabilities] = useState("");
    const [schedule, setSchedule] = useState({} as TutorSchedule);
    const [tempSchedule, setTempSchedule] = useState({} as TutorSchedule);
    const [tempAvailabilities, setTempAvailabilities] = useState("");
    const { currentUser } = useAuth();

    const [isEdited, setIsEdited] = useState(false);

    useEffect(() => {
        const currentSchedule = tutorProfile.Schedule;

        setSchedule(currentSchedule);
        setTempSchedule(currentSchedule);
        const availability = getAvailability(currentSchedule);
        setAvailabilities(availability);
        setTempAvailabilities(availability);


    }, [currentUser, tutorProfile]);

    useEffect(() => {
        if (availabilities.length !== tempAvailabilities.length) {
            setIsEdited(true);
            return;
        }
        const sortedDbAvailabilities = availabilities.split("").sort().join("");
        const sortedAvailabilities = tempAvailabilities.split("").sort().join("");
        if (sortedDbAvailabilities !== sortedAvailabilities) {
            setIsEdited(true);
            return;
        }
        for (const key in schedule) {
            if (schedule[key as keyof TutorSchedule] !== tempSchedule[key as keyof TutorSchedule]) {
            setIsEdited(true);
            return;
            }
        }
        setIsEdited(false);
    }, [tempAvailabilities, availabilities, schedule, tempSchedule]);

    const handelCancel = () => {
        setTempAvailabilities(availabilities);
        setTempSchedule(schedule);
    }

    const handelSave = async () => {
        for (const key in tempSchedule) {
            if (tempSchedule[key as keyof TutorSchedule] === schedule[key as keyof TutorSchedule]) {
                continue;
            }
            await updateTutorSchedule(key, tempSchedule[key as keyof TutorScheduleNoTimeZone]);
            await handleRefresProfile();
        }

        setIsEdited(false);
    }

    return (
        <div className="section-box p-4 grow gap-4 row-span-2">
            <div className="flex flex-row">
                <div className="flex flex-row">
                    <h3 className="section-title">Tutoring Availabilities</h3>
                </div>
            </div>
            <AvailabilitiesDay day={DaysOfWeek.Monday} availability={tempAvailabilities} setAvailability={setTempAvailabilities} setSchedule={setTempSchedule} schedule={tempSchedule}></AvailabilitiesDay>
            <AvailabilitiesDay day={DaysOfWeek.Tuesday} availability={tempAvailabilities} setAvailability={setTempAvailabilities} setSchedule={setTempSchedule} schedule={tempSchedule}></AvailabilitiesDay>
            <AvailabilitiesDay day={DaysOfWeek.Wednesday} availability={tempAvailabilities} setAvailability={setTempAvailabilities} setSchedule={setTempSchedule} schedule={tempSchedule}></AvailabilitiesDay>
            <AvailabilitiesDay day={DaysOfWeek.Thursday} availability={tempAvailabilities} setAvailability={setTempAvailabilities} setSchedule={setTempSchedule} schedule={tempSchedule}></AvailabilitiesDay>
            <AvailabilitiesDay day={DaysOfWeek.Friday} availability={tempAvailabilities} setAvailability={setTempAvailabilities} setSchedule={setTempSchedule} schedule={tempSchedule}></AvailabilitiesDay>
            <AvailabilitiesDay day={DaysOfWeek.Saturday} availability={tempAvailabilities} setAvailability={setTempAvailabilities} setSchedule={setTempSchedule} schedule={tempSchedule}></AvailabilitiesDay>
            <AvailabilitiesDay day={DaysOfWeek.Sunday} availability={tempAvailabilities} setAvailability={setTempAvailabilities} setSchedule={setTempSchedule} schedule={tempSchedule}></AvailabilitiesDay>
            {isEdited ? 
                <div className="text-xl flex flex-row-reverse gap-4">
                    <button className="primary-button" onClick={handelSave}>Save</button>
                    <button className="primary-button" onClick={handelCancel}>Cancel</button>
                </div> : ""}
        </div>
    );
}

function getAvailability(tutorSchedule: TutorSchedule): string {
    if (tutorSchedule === undefined) {
        return "";
    }
    var result = "";
    const days = Object.values(DaysOfWeek);
    days.forEach((day) => {
        if (tutorSchedule[getDayFromChar(day) as keyof TutorSchedule] !== 0) {
            result += day;
        }
    });
    return result;
}